import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BigNumberInputService {
  thousandSeparator = '.';
  decimalSeparator = ',';
  constructor() { }
  addSeparator(value: string, decimalSize: number): string {
    let startMinus:boolean=false;
    if (value == null) {
      return '';
    } else {
      value = value.replace('.', this.decimalSeparator)
      const num = value != undefined ? value : '';

      let decimalValue = num.split(this.decimalSeparator)[1] ? this.roundDecimal(num.split(this.decimalSeparator)[1], decimalSize) : this.roundDecimal('', decimalSize);
      let intValue :any;
      if(num.includes('-')){
          startMinus=true;
         intValue = num.split(this.decimalSeparator)[0] ? num.split(this.decimalSeparator)[0].substring(1) : '0';
      }else {
        startMinus=false;
        intValue = num.split(this.decimalSeparator)[0] ? num.split(this.decimalSeparator)[0]: '0';
      }

      intValue = this.removeZeros(intValue);
      let counter = 0;
      for (let index = intValue.length; index > 0; index--) {
        // const element = array[index];
        if (counter === 3) {
          intValue = intValue.slice(0, index) + this.thousandSeparator + intValue.slice(index);
          counter = 0;
        }
        counter++;
      }
      if (decimalValue) {
        decimalValue = this.decimalSeparator + decimalValue;
      } else {
        decimalValue = '';
      }
      if(startMinus){
        return '-' + intValue + decimalValue;
      }
      return intValue + decimalValue;
    }
  }
  roundDecimal(decimalValue: string, decimalSize: number) {
    if (decimalValue.length <= decimalSize) {
      let zeroToAdd = decimalSize - decimalValue.length;
      for (let i = 0; i < zeroToAdd; i++) {
        decimalValue += '0';
      }
    }
    return decimalValue
  }
  removeSeparator(value: string): string {

    value = value ? (value as any).replaceAll(this.decimalSeparator, '#').replaceAll(this.thousandSeparator, '').replaceAll("#", '.') : '';
    let array = value.split('.');
    let decimal = array[1] || '';
    if (decimal) {
      while (decimal.charAt(decimal.length - 1) == '0') {
        decimal = decimal.substr(0, decimal.length - 1);
      }
      if (decimal != '') {
        decimal = '.' + decimal;
      }
    }
    return array[0] + decimal;
  }  
  isAllowed(key:string,keyCode: number, ctrlKey:any,currentValue: string, integerSize: number, decimalSize: number, cursorPosition?: number,isNegative ?:boolean): boolean {
    if (cursorPosition == undefined) {
      cursorPosition = currentValue.length - 1;
    }
    if (!currentValue) {
      currentValue = '';
    }
    if (ctrlKey && (keyCode === 67 || keyCode === 86 || keyCode === 65)) {
      return true; //  Ctrl+C, Ctrl+V, and Ctrl+A
  }
    if(isNegative && key == '-'){
      return true;
    }
    const allowedNonNumberCaractersKeyCodes: number[] = [
      188,//KOMMA (,)
      46,//SUPR
      8, //DELETE
      37,//LEFT ARROW
      39,//RIGHT ARROW
      109 //MINUS
    ]

    //numeric field cannot containt a secend  komma
   
    let integerValue  = currentValue.startsWith('-') ? currentValue.substring(1) : currentValue ;
    
    let decimalValue = '';
    if (currentValue.includes(this.decimalSeparator)) {
      integerValue = integerValue.split(this.decimalSeparator)[0];
      decimalValue = currentValue.split(this.decimalSeparator)[1];
      allowedNonNumberCaractersKeyCodes.shift();

      if (decimalValue.length > 0) {
        //Blocking komma delete
        if (keyCode == 8) {
          //DELETE
          return cursorPosition != integerValue.length + 1
        }
        if (keyCode == 46) {
          //SUPR
          return cursorPosition != integerValue.length
        }
      }
    }
    if (!isNaN(Number(key))) {
      //NUMBER
      return (!currentValue.includes(this.decimalSeparator) && integerValue.length < integerSize) || (currentValue.includes(this.decimalSeparator) && ((decimalValue.length < decimalSize && cursorPosition > integerValue.length) || (integerValue.length < integerSize && cursorPosition <= integerValue.length)));
    }

    return (allowedNonNumberCaractersKeyCodes.includes(keyCode) ||(allowedNonNumberCaractersKeyCodes.includes(keyCode)&&key==",")  ||(allowedNonNumberCaractersKeyCodes.includes(keyCode)&&key=="-"))
  }

  removeZeros(number: string): string {
    if (number === '0') {
      return number;
    }
    return number.replace(/^0+/, '');
  }

}
